import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Automotivecs1 = () => {
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/automobilecase.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
            Accelerate the future of mobility
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      <Typography variant="body1" sx={{ color: "#333", fontSize: "18px" }}>
            Technology demands of the evolving automotive market require{" "}
            <strong>innovative</strong> and <strong>flexible cloud environments</strong>.
          </Typography>
      <Typography variant="body1" sx={{ mt: 2, color: "#333", fontSize: "18px"  }} mb={8}>
            Leading manufacturer Group, a multinational manufacturer of luxury vehicles and motorcycles,
            partnered with Tech Informatic Solutions to transform its computing infrastructure operations —
            migrating and integrating operations for worldwide data centers,
            <strong> driving improvements</strong> in efficiency, agility and automation.
          </Typography>
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
          The design, manufacture, sales and delivery of automobiles at a global scale
          requires operational efficiency and stability across all business functions. A{" "}
          <strong>high-performance, robust computing infrastructure</strong> is increasingly
          critical to driving functional innovation and success.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
          “Our clients rely on stable, secure and agile IT on which to run their
          organizations,” says Simon Winter, vice president of go-to market, Tech Informatic Solutions Services
          EMEA. “To focus on their core business rather than on managing IT, many of our
          clients turn to us for hybrid infrastructure services. With our over 200 state-of-art
          data centers and years of ITIL experience, we host business critical, secure
          infrastructures for clients worldwide.”
        </Typography>



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={8}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Streamlines global Windows and Linux/Unix computing environment",
                "Provides business continuity throughout an infrastructure transition",
                "Advances transformation to software-defined infrastructure"
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Builds global support for manufacturing and production lines, sales and marketing, showrooms and headquarters",
                "Improves performance and reliability with onsite, nearshore and offshore delivery",
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


      <Container sx={{ py: 10 }}>
      
       
      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Solution
          </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Streamlining data center operations
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Tech Informatic Solutions Services assumed responsibility for the leading manufacturer Group’s entire global server environment driving its manufacturing and production lines, sales and marketing offices, showrooms and headquarters operations.

        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Tech Informatic Solutions's Hybrid Infrastructure Managed Services operates the day-to-day operations of the enterprise compute landscape as a private cloud enabled by VMware technology delivering services from our facilities.

        </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Ensuring business continuity throughout the transition
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Transitioning global server operations to Tech Informatic Solutions was more involved than simply assigning a new pair of hands to the steering wheel.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        “Those server operations are business critical so ensuring a smooth transition of the management and support of the server environments to Tech Informatic Solutions while maintaining the stability of the environments was paramount,” says Mark Devonshire, vice president of delivery, Tech Informatic Solutions Services, EMEA. “We carefully developed and tested an approach which identified and minimized risks throughout the transition and onward into steady-state operations.”
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        The transitioned server operations offer a performant and resilient platform to support current operations as well as a foundation for further hybrid infrastructure services.  </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Next up: the software defined infrastructure </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The global electric mobility market is expected to grow rapidly and will drive general demand for robust in-car digital services and highly autonomous driving experiences.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        In anticipation of that, Tech Informatic Solutions is working with the leading manufacturer Group to transform its traditional compute operations into a software defined infrastructure environment. Tech Informatic Solutions's Cloud Transformation services will evolve the enterprise’s global server infrastructure into a hybrid cloud environment, virtualizing and automating the performance intensive workloads and services required to support the evolving electric mobility market. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        “We are excited by the opportunities to support our clients in their cloud transformation journeys,” says Winter, “as aligning cloud strategies with business and market demands will help unlock potential and drive continuous innovation and growth.”  </Typography>

</Container>



<Footer/>
    </Box>


  );
};

export default Automotivecs1;
